var WarmupQuestions = require("lib/academic/WarmupQuestions");

class FictionPicturesQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionPicturesQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [NUM_PICS_STAGE];
		}

		var numPics = answers[NUM_PICS];
		if (numPics == "0") {
			return [NUM_PICS_STAGE, true];
		}

		if (!answers[PIC1_DESC] || (this.props.level != "1" && !answers[PIC1_ADJ])) {
			return [PIC1_STAGE];
		} else if (numPics == "1") {
			return [PIC1_STAGE, true];
		}

		if (!answers[PIC2_DESC] || (this.props.level != "1" && !answers[PIC2_ADJ])) {
			return [PIC2_STAGE];
		}
		
		return [PIC2_STAGE, true];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var numPicsDisplay = (
			<div>
				{ this.props.getTextF("label1", NUM_PICS_STAGE) }
				{ this.props.renderDropdownF("choices1", NUM_PICS_STAGE, NUM_PICS, [NUM_PICS]) }
				{ this.props.getTextF("label2", NUM_PICS_STAGE) }.
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			if (this.props.level != "1") {
				var additionalPic1Display = (
					<div>
						{ this.props.getTextF("label2", PIC1_STAGE) }
						{ this.props.renderMultiSelectF("choices2", PIC1_STAGE, PIC1_ADJ, 1) }
					</div>
				);
			}

			var pic1Display = (
				<div>
					{ this.props.getTextF("label1", PIC1_STAGE) }
					{ this.props.renderInputF(PIC1_DESC) }
					{ additionalPic1Display }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			if (this.props.level != "1") {
				var additionalPic2Display = (
					<div>
						{ this.props.getTextF("label2", PIC2_STAGE) }
						{ this.props.renderMultiSelectF("choices2", PIC2_STAGE, PIC2_ADJ, 1) }
					</div>
				);
			}

			var pic2Display = (
				<div>
					{ this.props.getTextF("label1", PIC2_STAGE) }
					{ this.props.renderInputF(PIC2_DESC) }
					{ additionalPic2Display }
				</div>
			);
		}

		return (
			<div>
				{ numPicsDisplay }
				{ pic1Display }
				{ pic2Display }
				{ finishButtonDisplay }
			</div>
		);
	}
}

FictionPicturesQuestion.STEM = "fpic";

// stages
var NUM_PICS_STAGE = "numpics";
var PIC1_STAGE = "pic1";
var PIC2_STAGE = "pic2";

var STAGES = [
	NUM_PICS_STAGE, PIC1_STAGE, PIC2_STAGE
];

// answer keys
var NUM_PICS = "num_pictures";
var PIC1_DESC = "picture_1_description";
var PIC1_ADJ = "picture_1_adjective";
var PIC2_DESC = "picture_2_description";
var PIC2_ADJ = "picture_2_adjective";

FictionPicturesQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderMultiSelectF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = FictionPicturesQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionPicturesQuestion.js